import { UseFormTrigger } from 'react-hook-form';
import { Dispatch, SetStateAction } from 'react';
import { GroupTemplateFormData } from './group-template-form-data';

import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';

interface CreateTemplateStepsProps {
  activeStep: number;
  setActiveStep: (step: number) => void;
  steps: string[];
  trigger: UseFormTrigger<GroupTemplateFormData>;
  stepCompleted: boolean[];
  setStepCompleted: Dispatch<SetStateAction<boolean[]>>;
}

export default function CreateTemplateSteps({
  activeStep,
  setActiveStep,
  steps,
  trigger,
  stepCompleted,
  setStepCompleted,
}: CreateTemplateStepsProps) {
  async function onStepClick(step: number) {
    if (step === activeStep) return;

    const isValid = await trigger();

    if (isValid) {
      setActiveStep(step);
      setStepCompleted((prev) => {
        // complete all steps before the current step
        for (let i = 0; i < step; i++) {
          prev[i] = true;
        }

        const newSteps = [...prev];
        newSteps[step] = true;
        return newSteps;
      });
    }
  }

  return (
    <Box sx={{ mt: 4, p: 2, pb: 1 }}>
      <Stepper nonLinear activeStep={activeStep} sx={{ cursor: 'pointer' }}>
        {steps.map((step, index) => {
          return (
            <Step
              key={step}
              onClick={() => onStepClick(index)}
              completed={stepCompleted[index]}
            >
              <StepLabel>{step}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
}
